import { StatusWrapper } from '@/components/StatusWrapper/StatusWrapper';
import { STATUS_VARIANT_HIGHLIGHT, StatusType } from '@/components/StatusWrapper/const';
import { ORGANIZATION_USER_STATUS, OrganizationUserStatusType } from '@/const/user';

export const ORGANIZATION_ADMIN_STATUS_MAP: StatusType = {
  [ORGANIZATION_USER_STATUS.ACTIVE]: { title: 'Active', variant: STATUS_VARIANT_HIGHLIGHT.GREEN },
  [ORGANIZATION_USER_STATUS.BLOCKED]: { title: 'Blocked', variant: STATUS_VARIANT_HIGHLIGHT.GREY },
  [ORGANIZATION_USER_STATUS.INVITED]: { title: 'Invited', variant: STATUS_VARIANT_HIGHLIGHT.LIGHT_PURPLE },
  [ORGANIZATION_USER_STATUS.UNCONFIRMED]: { title: 'Unconfirmed', variant: STATUS_VARIANT_HIGHLIGHT.ROSE },
};

type AdminUserStatusType = {
  status: OrganizationUserStatusType;
};

export const AdminUserStatus = ({ status }: AdminUserStatusType) => {
  const statusMap = ORGANIZATION_ADMIN_STATUS_MAP[status];

  return <StatusWrapper variant={statusMap?.variant}>{statusMap?.title}</StatusWrapper>;
};
